import { useEffect, useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { DOUBLE_RIGHTCHEVRON, HOME_ICON } from '../assets/icons';

export let routes: { [x: string]: string } = {
  Home: '/',
  'Tutor Management': '/tutor-management',
  'Student Management': '/student-management',
  Requests: '/tutor-management/requests',
  Manage: '/tutor-management/manage',

  'General Management': '/general-management',
  Legal: '/general-management/legal',
  Categories: '/general-management/categories',
  'Add Skill': '/general-management/categories/addSkill',
  'Add Subject': '/general-management/categories/addSubject',
  'Add Hobby': '/general-management/categories/addHobby',
  Pricing: '/general-management/pricing',

  'Plan Management': '/plan-management',
  Bookings: '/plan-management/bookings',
  'Change Requests': '/plan-management/change-requests',
  'Class Management': '/class-management',
  Classes: '/class-management/classes',
  Disputes: '/class-management/disputes'
};

export default function BreadCrumb() {
  const location = useLocation();
  const pathSnippets = location.pathname.split('/').filter((i) => i);
  const [breadcrumbNameMap, setBreadcrumbNameMap] = useState<{
    [x: string]: string;
  }>({});

  const { student_id, planId } = useParams();

  useEffect(() => {
    if (student_id) {
      routes = {
        ...routes,
        [student_id]: `/student-management/${student_id}`,
        Profile: `/student-management/${student_id}/profile`,
        Transactions: `/student-management/${student_id}/transactions`,
        Plans: `/student-management/${student_id}/plans`,
        Attendance: `/student-management/${student_id}/attendance`,
        Calendar: `/student-management/${student_id}/calendar`,
        'Plan Attendance': `/student-management/${student_id}/plans/${planId}/attendance`
      };
      if (planId) {
        routes = {
          ...routes,
          [planId]: `/student-management/${student_id}/plans/${planId}`
        };
      }
    }
  }, [student_id]);

  useEffect(() => {
    let temp: { [x: string]: string } = {};
    Object.keys(routes).forEach((route) => {
      temp[routes[route]] = route;
    });
    setBreadcrumbNameMap(temp);
  }, []);

  const extraBreadcrumbItems = pathSnippets.map((_, index) => {
    const url = `/${pathSnippets.slice(0, index + 1).join('/')}`;
    return (
      // <BreadcrumbItem key={url} url={url} name={breadcrumbNameMap[url]} />
      <BreadcrumbItem2 key={url}>
        <div className="flex gap-1.5 items-center">
          <img src={DOUBLE_RIGHTCHEVRON} className="w-3" />
          <Link to={url}>
            <p className="text-xs text-primary/80">{breadcrumbNameMap[url]}</p>
          </Link>
        </div>
      </BreadcrumbItem2>
    );
  });

  const breadcrumbItems = [
    <BreadcrumbItem2 key={'/'}>
      <Link to={'/'}>
        <img src={HOME_ICON} className="w-4" />
      </Link>
    </BreadcrumbItem2>
  ].concat(extraBreadcrumbItems);

  return <div className="flex items-center gap-2">{breadcrumbItems}</div>;
}

function BreadcrumbItem2({ children }: { children: JSX.Element }) {
  return <>{children}</>;
}
